import {
  typographyStyles,
  constants,
  cssVariableStyles,
} from "@newsela/angelou";

import {
  bodyLineHeight,
  powerWordPopOutBodyFontSizes,
  powerWordPopOutHeaderFontSizes,
  powerWordPopOutIconSizes,
  powerWordPopOutTitleFontSizes,
} from "@/view/constants/styles/accessibleFontSizeMapping/accessibleFontSizeMapping.style";

const { generateTooltipDialogVariables } = cssVariableStyles;
const { colors } = constants;
const { fontFamily } = typographyStyles;
const { circular } = fontFamily;
const grey = colors.ui.neutral[500];
const greyDark = colors.ui.neutral[600];
const greyDarkest = colors.ui.neutral[700];
const green = colors.ui.green[300];

const getIconSize = (currentFontSize) =>
  powerWordPopOutIconSizes[currentFontSize];

export const dialogStyles = generateTooltipDialogVariables({
  backgroundColor: colors.ui.white[700],
  borderWidth: "2px",
});

export const containerCss = {
  ...dialogStyles,
  fontFamily: circular.fontFamily,
  minHeight: "146px",
  padding: "12px",
  width: "287px",
  zIndex: 2,
};

export const closeIconCss = (accessibleFontSize) => ({
  height: getIconSize(accessibleFontSize),
  "--icon-width": getIconSize(accessibleFontSize),
});

export const headerCss = (accessibleFontSize) => ({
  position: "relative",
  top: "-2px",
  color: greyDark,
  fontSize: powerWordPopOutHeaderFontSizes[accessibleFontSize],
  letterSpacing: "1px",
  margin: "0",
  textTransform: "uppercase",
});

export const boltIconCss = (accessibleFontSize) => ({
  marginRight: "6px",
  height: getIconSize(accessibleFontSize),
  width: getIconSize(accessibleFontSize),
  fill: green,
  path: {
    stroke: green,
  },
});

export const powerWordWrapperCss = {
  alignItems: "center",
  display: "flex",
  marginBottom: "16px",
};

export const powerWordCss = (accessibleFontSize) => ({
  color: greyDarkest,
  display: "inline-block",
  margin: "0",
  fontSize: powerWordPopOutTitleFontSizes[accessibleFontSize],
});

export const readAloudIconCss = (accessibleFontSize) => ({
  color: greyDarkest,
  height: getIconSize(accessibleFontSize),
  width: getIconSize(accessibleFontSize),
});

export const readAloudButtonOverrideCss = {
  padding: 3,
  marginLeft: 8,
  position: "relative",
};

export const definitionBodyCss = (accessibleFontSize) => ({
  color: grey,
  fontSize: powerWordPopOutBodyFontSizes[accessibleFontSize],
  lineHeight: bodyLineHeight,
});

export const tooltipArrowCss = {
  ":before": {
    width: "11px",
    height: "11px",
  },
};

export const headerWrapperCss = {
  display: "flex",
  margin: "3px 0 16px 0",
};
